import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=18efda5c&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
import style0 from "./Container.vue?vue&type=style&index=0&id=18efda5c&prod&scoped=true&lang=css"
import style1 from "./Container.vue?vue&type=style&index=1&id=18efda5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18efda5c",
  null
  
)

export default component.exports